module.exports = __webpack_public_path__ + "img/swiper_3.41156a35.jpg";